import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const SignupOtp = () => {
  const navigate = useNavigate();
  const { signupState, updateSignupState } = useSignup();
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!signupState.mobile || !signupState.mobileOtp) {
      navigate('/signup/mobile', { replace: true });
    }
  }, [signupState.mobile, signupState.mobileOtp, navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (otp.trim().length !== 6) {
      toast.error('Please enter the 6-digit OTP');
      return;
    }

    setLoading(true);

    if (otp.trim() !== signupState.mobileOtp) {
      toast.error('Invalid OTP. Please try again.');
      setLoading(false);
      return;
    }

    updateSignupState({
      otpVerified: true,
    });

    toast.success('OTP verified');
    navigate('/signup/pan');
    setLoading(false);
  };

  const handleBack = () => {
    navigate('/signup/mobile');
  };

  return (
    <AuthLayout
      title="Verify mobile"
      subtitle={`Enter OTP sent to ${signupState.mobile || 'your mobile number'}`}
      onBack={handleBack}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">OTP</label>
          <input
            type="tel"
            className="form-input"
            maxLength={6}
            value={otp}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setOtp(value);
            }}
            placeholder="Enter 6-digit OTP"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupOtp;


